import axios from "axios";

//IMPORT API ROUTE URL
import { CREATE_JOB_VIA_PARSING_ROUTE } from "./apiRoutes";

const createJobViaParsing = (data) => {
  var postData = new FormData();

  postData.append("user_slug", data.user_slug);
  postData.append("file", data.file);

  return axios
    .post(CREATE_JOB_VIA_PARSING_ROUTE, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default createJobViaParsing;
